import React, { Component } from "react";
import axios from "axios";
import { LangContext } from "../LangContext.jsx"; 

class ApiPersonTokenList extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      tokens: [],
      search: '',
      clipboard: false,
      permissions: [],
    };
  }

  componentDidMount() {
    this.getPermissions();
    this.getTokens();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search !== this.state.search) {
      this.getTokens();
    }
  }

  handleChange = (ev) => {
    this.setState({ search: ev.target.value });
  };

  getPermissions = async () => {
    const URL = `/api/permissions`;
    await axios.get(URL).then((res) => {
      this.setState({ permissions: res.data });
    });
  };

  getTokens = async () => {
    const { search } = this.state;
    let search_q = search != '' ? '?search=' + search : '';
    const URL = `/people/api/tokens${search_q}`;
    await axios.get(URL).then((res) => {
      this.setState({ tokens: res.data.tokens });
    });
  };

  deleteToken = (id) => {
    const { lang } = this.context;
    window.blockUI(lang.get('messages.procesando'));
    axios
      .post(
        '/people/delete/' + id,
        {},
        {
          headers: {
            'content-type': 'application/json',
          },
        }
      )
      .then(() => {
        window.unblockUI();
        this.getTokens();
      })
      .catch((error) => {
        window.unblockUI();
        const message = error?.response?.data?.message || lang.get('messages.error');
        swal
          .fire({
            text: message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.aceptar'),
            customClass: { confirmButton: 'btn font-weight-bold btn-light-primary' },
          })
          .then(function () {
            KTUtil.scrollTop();
          });
      });
  };

  copy = () => {
    const token = this.props.token;
    navigator.clipboard.writeText(token);
    this.setState({ clipboard: true });
  };

  confirmDelete = (id) => {
    const { lang } = this.context;
    swal
      .fire({
        text: lang.get('messages.desea_continuar_con_la_eliminacion'),
        showCancelButton: true,
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: lang.get('messages.continuar'),
        cancelButtonText: lang.get('messages.cancelar'),
        customClass: {
          confirmButton: 'btn font-weight-bold btn-light-primary',
          cancelButton: 'btn font-weight-bold btn-danger',
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.deleteToken(id);
        }
      });
  };

  render() {
    const { lang } = this.context;
    const { tokens, clipboard } = this.state;
    const token = this.props.token;

    return (
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom gutter-b">
            <div className="card-header border-0 pt-7">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Api</span>
                <span className="text-muted mt-3 font-weight-bold font-size-sm">{tokens.length} Apis</span>
              </h3>
              <div className="card-toolbar">
                <div>
                  {/* Search box commented out intentionally */}
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="tab-content mt-2" id="myTabTable5">
                <div className="tab-pane fade active show" id="tpiall" role="tabpanel" aria-labelledby="tpiall">
                  <div className="table-responsive">
                    {token != null ? (
                      <div>
                        <div className="alert alert-success d-flex" role="alert">
                          <div style={{ marginRight: '10px' }}>
                            <span className="svg-icon svg-icon-secondary svg-icon-3x">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <rect x="0" y="0" width="24" height="24" />
                                  <path d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z" fill="#000000" opacity="0.3" />
                                  <rect fill="#000000" x="11" y="9" width="2" height="7" rx="1" />
                                  <rect fill="#000000" x="11" y="17" width="2" height="2" rx="1" />
                                </g>
                              </svg>
                            </span>
                          </div>
                          <div>
                            {lang.get('messages.precaucion')}<br />
                            {lang.get('messages.asegurate_de_copiar_el_acceso_a_tu_token_ahora_este_no_podra_ser_consultado_nuevamente')}
                          </div>
                        </div>
                        <div className="newToken">
                          {token}
                          {clipboard ? (
                            <span onClick={this.copy} className="svg-icon svg-icon-secondary svg-icon-2x">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <rect x="0" y="0" width="24" height="24" />
                                  <path d="M15.9956071,6 L9,6 C7.34314575,6 6,7.34314575 6,9 L6,15.9956071 C4.70185442,15.9316381 4,15.1706419 4,13.8181818 L4,6.18181818 C4,4.76751186 4.76751186,4 6.18181818,4 L13.8181818,4 C15.1706419,4 15.9316381,4.70185442 15.9956071,6 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                  <path d="M10.1818182,8 L17.8181818,8 C19.2324881,8 20,8.76751186 20,10.1818182 L20,17.8181818 C20,19.2324881 19.2324881,20 17.8181818,20 L10.1818182,20 C8.76751186,20 8,19.2324881 8,17.8181818 L8,10.1818182 C8,8.76751186 8.76751186,8 10.1818182,8 Z" fill="#000000" />
                                </g>
                              </svg>{' '}
                            </span>
                          ) : (
                            <span onClick={this.copy} className="svg-icon copy-clipboard svg-icon-primary svg-icon-2x">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <rect x="0" y="0" width="24" height="24" />
                                  <path d="M15.9956071,6 L9,6 C7.34314575,6 6,7.34314575 6,9 L6,15.9956071 C4.70185442,15.9316381 4,15.1706419 4,13.8181818 L4,6.18181818 C4,4.76751186 4.76751186,4 6.18181818,4 L13.8181818,4 C15.1706419,4 15.9316381,4.70185442 15.9956071,6 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                  <path d="M10.1818182,8 L17.8181818,8 C19.2324881,8 20,8.76751186 20,10.1818182 L20,17.8181818 C20,19.2324881 19.2324881,20 17.8181818,20 L10.1818182,20 C8.76751186,20 8,19.2324881 8,17.8181818 L8,10.1818182 C8,8.76751186 8.76751186,8 10.1818182,8 Z" fill="#000000" />
                                </g>
                              </svg>{' '}
                            </span>
                          )}
                        </div>
                      </div>
                    ) : null}
                    {tokens.length == 0 ? (
                      <p>{lang.get('messages.no_tienes_tokens_registrados')}</p>
                    ) : (
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="border-0">{lang.get('messages.token')}</th>
                            <th className="border-0">{lang.get('messages.expiracion')}</th>
                            <th className="border-0">{lang.get('messages.utilizado')}</th>
                            <th className="border-0"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {tokens.map((token, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="symbol symbol-40">
                                    <div className="symbol-label bg-white">
                                      <i className="flaticon2-lock text-primary"></i>
                                    </div>
                                  </div>
                                  <span className="text-dark-75 font-weight-bolder font-size-lg">{token.name}</span>
                                </td>
                                <td>
                                  {token.expired_at == null ? (
                                    <p> {lang.get('messages.no_expira')} </p>
                                  ) : (
                                    <>
                                      {token.expired == true ? (
                                        <span>
                                          <span className="badge badge-danger  badge-inline badge-pill">{lang.get('messages.expirado')}</span>
                                          <br />
                                          <span>
                                            {lang.get('messages.expiro_en')} <strong> {token.expired_at}</strong>
                                          </span>
                                        </span>
                                      ) : (
                                        <span>
                                          {lang.get('messages.expira_en')} <strong> {token.expired_at}</strong>
                                        </span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td>
                                  {token.last_used_at == null ? (
                                    <i className="font-size-lg">{lang.get('messages.nuevo_token')}</i>
                                  ) : (
                                    <i className="font-size-lg">
                                      {lang.get('messages.ultima_vez_que_se_utilizo')}: {token.last_used_at}
                                    </i>
                                  )}
                                </td>
                                <td>
                                  {(this.props.permissions.api.includes('all') || this.props.permissions.api.includes('delete')) && (
                                    <div style={{ width: '10%', textAlign: 'right' }}>
                                      <a onClick={() => { this.confirmDelete(token.id); }} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                        <i className="flaticon-delete fw-normal text-primary"></i>
                                      </a>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ApiPersonTokenList;
